<template>
    <sa-page-layout btnRefreshVisible @refresh="onRefresh" :linkedit="linkedit" btnNewVisible>
        <!-- <template slot="toolbar">
      <b-button @click="onOpenModalDatiDocumenti" size="sm" class="float-sm-right" variant="success btn-toolbar"> <b-icon icon="plus"></b-icon>Nuovo</b-button>
    </template> -->
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Struttura</label>
                        <b-form-select v-model="filtroDocumenti.strutturaCodice" :options="strutturaOptions" :value="null" value-field="codiceStruttura" text-field="denominazione">
                            <template #first>
                                <b-form-select-option :value="null">- Tutte -</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Data Dal</label>
                        <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="filtroDocumenti.dataDal" type="datetime" placeholder="Data Dal"></date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Data Al</label>
                        <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="filtroDocumenti.dataAl" type="datetime" placeholder="Data Al"></date-picker>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Numero Documento</label>
                        <b-form-input v-model="filtroDocumenti.numeroDocumento" type="search" id="numeroDocumento" placeholder="Numero Documento"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Tipo Documento</label>
                        <b-form-select v-model="filtroDocumenti.idTipoDocumento" :options="contabilitaTipoDocumentoOptions" :value="null" value-field="id" text-field="descrizioneTipoDocumento">
                            <template #first>
                                <b-form-select-option :value="null">- Tutti -</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Ragione Sociale</label>
                        <b-form-input v-model="filtroDocumenti.cognomeRagioneSoggetto" type="search" id="ragioneSoggetto" placeholder="Ragione Sociale"></b-form-input>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem"> </b-row>
                <b-row class="sa-form-btn-filter">
                    <b-col class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">Cerca</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">Resetta Filtro</b-button>
                    </b-col>
                </b-row>
            </b-form>
            <sa-modal-loading ref="mdlSaModalLoading"></sa-modal-loading>
        </template>
        <template slot="table-body">
            <contabilita-documenti-list-component ref="cmpContabilitaDocumentiListComponent" @afterLoadData="onAfterLoadDataContabilitaDocumentiListComponent"></contabilita-documenti-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ContabilitaDocumentiListComponent from "../components/ContabilitaDocumentiListComponent.vue";
import DatePicker from "vue2-datepicker";
import { SaModalLoading } from "../../utility";
import UtilityMixin from "../../utility/UtilityMixin";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import ContabilitaMixin from "../mixins/ContabilitaMixin";

export default {
    mixins: [UtilityMixin, StruttureMixin, ContabilitaMixin],
    components: { SaPageLayout, DatePicker, SaModalLoading, ContabilitaDocumentiListComponent },

    data() {
        return {
            presidio: null,
            linkedit: "/contabilita/documenti",
            filtroDocumenti: { strutturaCodice: null, dataDal: null, dataAl: null, numeroDocumento: null, idTipoDocumento: null, cognomeRagioneSoggetto: null },
        };
    },
    mounted() {
        let sessionStorage = window.sessionStorage;
        let filtroDocumenti = sessionStorage.getItem("filtroDocumenti");
        if (filtroDocumenti) {
            this.filtroDocumenti = JSON.parse(filtroDocumenti);
        }
        this.struttureLoadData();
        this.loadDefaulData();
    },
    methods: {
        loadDefaulData() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
                this.filtroDocumenti.strutturaCodice = this.presidio.codiceStruttura;
            }
            this.contabilitaTipoDocumentoLoadData(this.filtroDocumenti.strutturaCodice);
            this.loadData();
        },
        loadData() {
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroDocumenti", JSON.stringify(this.filtroDocumenti));

            this.$refs.cmpContabilitaDocumentiListComponent.loadData(this.filtroDocumenti);
        },
        onRefresh() {
            let me = this;
            let filter = sessionStorage.getItem("filtroDocumenti");
            filter = JSON.parse(filter);
            me.$refs.cmpContabilitaDocumentiListComponent.refresh(filter);
        },
        onSubmit() {
            this.loadData();
        },
        onReset() {},
        onAfterLoadDataContabilitaDocumentiListComponent() {
            this.$refs.mdlSaModalLoading.close();
        },
    },
};
</script>

<style></style>
